import React, { useEffect, useRef, useState } from 'react';
import Loader from './../../commonComponents/activityIndicator/activityIndicator';
import { Dimensions, Image, ImageBackground, Text, TouchableOpacity, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutApi, addRentalInfo, changePassword, contactUs, deleteRentalInfo, editRentalInfo, fetchDoc, getProfile, getRentReadyProfile, getRentalInfo, referFriend, updateNotiSettings, updateProfile, updateRentReadySettings } from '../../redux/actions/auth';
import getPlatformType from '../../helpers/getPlatform';
import NotificationList from '../notificationSettings/NotificationList';
import { getDigitalVerificationStatus } from '../openFlow/helpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import CustomPopUp from '../../commonComponents/customPopUp/customPopUp';
import { navigateAction, replaceAction } from '../../helpers/navigationHelpers';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import MyAccountPanel from '../../../openbrix-design-system/ui/molecules/Account/MyAccountPanel/MyAccountPanel';
import MyAccountCard from '../../../openbrix-design-system/ui/molecules/Account/MyAccount/MyAccount';
import SavedPropertiesCard from '../../../openbrix-design-system/ui/molecules/Account/SavedPropertiesCard/SavedPropertiesCard.web';
import AlertCard from '../../../openbrix-design-system/ui/molecules/Account/AlertCard/AlertCard';
import ReferAFriendCard from '../../../openbrix-design-system/ui/molecules/Account/ReferAFriend/ReferAFriendCard';
import SettingsCards from '../../../openbrix-design-system/ui/molecules/Account/Settings/SettingsCard';
import { ODSModal } from '../../../openbrix-design-system/ui/atoms/ODSModal/ODSModal.web';
import ChangePasswordCard from '../../../openbrix-design-system/ui/molecules/Account/ChangePasswordCard/ChangePasswordCard';
import ContactUsCard from '../../../openbrix-design-system/ui/molecules/Account/ContactUsCard/ContactUsCard';
import { useNavigation, useRoute } from '@react-navigation/native';
import ShareMedia from '../../commonComponents/shareMedia/shareMedia.web';
import { types } from '../../redux/actionTypes';
import MyInvoiceCard from '../../../openbrix-design-system/ui/molecules/Account/MyInvoices/MyInvoices';
import MyRentalInfo from '../../../openbrix-design-system/ui/molecules/Account/MyRentalInfor';
import SubscriptionList from '../subscriptionList';
import RentReadySettingsCard from '../../../openbrix-design-system/ui/molecules/Account/RentReadySettings/RentReadySettingsCard';
import { usePageTracking } from '../../helpers/analytics';

const layoutType = getPlatformType();

const MyAccount = (props) => {
    const dispatch = useDispatch();
    const scrollViewRef = useRef(null);
    const [deletePopUpIsVisible, setDeletePopUpIsVisible] = useState(false);
    const [rentalData, setRentalData] = useState({});
    const route = useRoute();
    const [rentalProfile, setRentalProfile] = useState({
        is_tenant_info_shared: false,
        is_right_to_rent_shared: false,
        is_affordability_shared: false,
        is_pre_reference_shared: false,
        is_rental_ledger_shared: true,
        is_id_verification_shared: true,
        is_guarantor_affordability_shared: false
    });


    const [state, setState] = React.useState({
        currentTab: 'tab1',
        firstName: '',
        lastName: '',
        contact: '',
        email: '',
        user_id: '',
        idverificationStatus: '',
        yoti_reason: '',
        opbrix_id: '',
        TextInputDisableHolder: true,
        prevProfile: null,
        showDetails: false,
        contactError: '',
        isTenantOrBuyer: '',
        showLoading: false,
        address: ''
    });

    const { navigate } = useNavigation();
    const docs = useSelector((state) => state?.authReducer?.docs);
    const profileLoading = useSelector((state) => state.authReducer.profileLoading);
    const profile = useSelector((state) => state.authReducer.profile);
    const rental_profile = useSelector((state) => state.authReducer?.rental_profile?.data);

    useEffect(() => {
        dispatch(getProfile({}, props.navigation.navigate));
        dispatch(getRentalInfo({}, props.navigation.navigate));
        dispatch(fetchDoc());
        dispatch(getRentReadyProfile((res) => {
            console.log("rental_profile", res)
            if (res.status) {
                res.data && setRentalProfile(res.data);
            }
        }));

        window.scrollTo(0, 0);
    }, [selectedId]);


    const onProfileUpdate = (data) => {
        dispatch(
            updateProfile({
                user: {
                    first_name: data.firstName,
                    last_name: data.lastName,
                    contact_number: data.contact,
                    user_id: state.user_id,
                    user_type: 0,
                    title: data.title,
                    address: data.address,
                },
            })
        );
    }
    const onContactUs = (data) => {
        dispatch(
            contactUs({
                email: data.email,
                topic: data.subject,
                name: data.firstName,
                message: data.message,
            })
        );
    }
    const onChangePassword = (data) => {
        dispatch(changePassword(
            {
                newPassword: data.newPassword,
                currentPassword: data.currentPassword,
            },
            navigate,
        ))
    }
    const onReferAFriend = (email) => {
        dispatch(referFriend({ email: email }, () => {

        }))
    }
    const onUpdateSettings = (data) => {
        let req = {
            property_notification: data.property_notification,
            marketplace_notification: data.marketplace_notification,
            rental_notification: data.rental_notification,
            maintenance_notification: data.maintenance_notification,
            openflow_notification: data.openflow_notification,
        };
        dispatch(updateNotiSettings(req))
    }
    const onUpdateRentReadySettings = (data) => {
        let req = {
            is_tenant_info_shared: data.is_tenant_info_shared,
            is_right_to_rent_shared: data.is_right_to_rent_shared,
            is_affordability_shared: data.is_affordability_shared,
            is_pre_reference_shared: data.is_pre_reference_shared,
            is_rental_ledger_shared: data.is_rental_ledger_shared,
            is_id_verification_shared: data.is_id_verification_shared,
            is_guarantor_affordability_shared: data.is_guarantor_affordability_shared,
            default_documents_shared: data.default_documents_shared || [],
        };
        dispatch(updateRentReadySettings(req, () => {
            dispatch(getRentReadyProfile((res) => {
                console.log("rental_profile", res)
                if (res.status) {
                    res.data && setRentalProfile(res.data);
                }
            }));
        }))
    }
    const onAddRentalInfo = (data) => {
        let req = {
            "property_name": data?.property_name,
            "rental_amount": data.rental_amount,
            "deposit_amount": data.deposit_amount,
            "property_address": data.property_address,
            "rental_start_date": new Date(data.rental_start_date).toISOString(),
            "expected_end_date": new Date(data.expected_end_date).toISOString(),
            "property_post_code": data.property_post_code,
        };
        dispatch(addRentalInfo(req))
    }
    const onEditRentalInfo = (data) => {
        let req = {
            "property_name": data?.property_name,
            "rental_amount": data.rental_amount,
            "deposit_amount": data.deposit_amount,
            "property_address": data.property_address,
            "rental_start_date": new Date(data.rental_start_date).toISOString(),
            "expected_end_date": new Date(data.expected_end_date).toISOString(),
            "property_post_code": data.property_post_code,
            "rental_profile_id": data?.rental_profile_id
        };
        console.log("reqreq000", data)
        console.log("reqreq1111", req)
        dispatch(editRentalInfo(req))
    }
    const onDelereRentalInfo = (id) => {
        dispatch(deleteRentalInfo(id))
    }
    useEffect(() => {
        if (profile != undefined) {
            setState({
                ...state,
                firstName: profile.data.first_name,
                lastName: profile.data.last_name,
                contact: profile.data.contact_number,
                email: profile.data.email,
                idverificationStatus: profile?.data?.appUser?.idverification,
                yoti_reason: profile.data?.appUser?.yoti_reason,
                opbrix_id: profile?.data?.appUser?.opbrix_id,
                user_id: profile.data.user_id,
                title: profile?.data?.title,
                address: profile?.data?.address,

            });
        }
    }, [profile]);
    useEffect(() => {
        if (rental_profile && setRentalData.length) {
            setRentalData(rental_profile);
        } else {
            setRentalData([])
        }
    }, [rental_profile]);

    useEffect(() => {
        if (profile != undefined) {
            setState({
                ...state,
                firstName: profile.data.first_name,
                lastName: profile.data.last_name,
                contact: profile.data.contact_number,
                email: profile.data.email,
                idverificationStatus: profile?.data?.appUser?.idverification,
                yoti_reason: profile.data?.appUser?.yoti_reason,
                opbrix_id: profile?.data?.appUser?.opbrix_id,
                user_id: profile.data.user_id,
                title: profile?.data?.title,
                address: profile?.data?.address,

            });
        }
    }, [profile]);
    const onCopyPress = (e) => {
        navigator.clipboard.writeText(e);
        dispatch({ type: types.SHOW_ALERT, alertType: "success", text: "ID Copied" });
    }



    const { colors } = useTheme();
    const [selectedId, setSelectedId] = useState(route?.params?.to === 'subscriptions' ? 'invoice' : route?.params?.to || 'profile');

    useEffect(() => {
        setSelectedId(route?.params?.to === 'subscriptions' ? 'invoice' : route?.params?.to || 'profile');
        if (route?.params?.to === "rent-ready-settings") {
            window.scrollTo(0, 0);
        }
    }, [route?.params?.to])

    return (
        <BackGroundGenerator scrollViewRef={scrollViewRef} props={props} isTLYF>

            <Loader loading={profileLoading} />
            <ImageBackground
                source={require('../../../openbrix-design-system/images/banner/web/my-account.png')}
                style={{
                    width: '100%',
                    height: '246px',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}
                resizeMode="cover"
            >
                <ODSButton
                    rIcon={'TB-Arrow-Left'}
                    restStyle={{ marginTop: 20, marginLeft: layoutType == "web" ? 60 : 20 }}
                    type="secondary"
                    disabled={false}
                    onPress={() => replaceAction(props?.navigation, 'Dashboard')}
                >
                    Back
                </ODSButton>
            </ImageBackground>
            <ODSText type='h3' marginVertical={32} color={colors.text.primary} textAlign='center'>My Account</ODSText>
            <View style={{ flexDirection: 'row', width: layoutType == "web" ? 1050 : layoutType == "tab" ? 700 : '100%', alignSelf: 'center', paddingHorizontal: 16, marginBottom: 40, alignItems: 'flex-start', gap: 24 }}>
                <View style={{ width: layoutType == "web" ? 377 : '100%' }}>
                    <MyAccountPanel selectedId={layoutType == "web" ? selectedId : ''} onPress={(id) => {
                        scrollViewRef.current.scrollTo({ y: 200, animated: true });
                        if (layoutType === 'web') {
                            if (id !== 'delete') {
                                if (id === 'profile') {
                                    navigateAction(props?.navigation, "My Account");
                                } else {
                                    navigateAction(props?.navigation, "My Account To", { to: id });
                                }
                            } else {
                                setSelectedId(id);
                            }
                        } else {
                            setSelectedId(id);
                            id != 'delete' &&
                                navigateAction(props?.navigation, "MyAccount", { useremail: state?.email, id: id, data: state, idStatus: getDigitalVerificationStatus(state.idverificationStatus).StatusText, navigation: props.navigation })
                        }
                    }} />
                </View>
                <View style={{ width: 1, height: 1200, marginHorizontal: 16, backgroundColor: '#D0D6DD' }} />
                {layoutType == "web" && <View style={{ width: 625 }}>
                    {selectedId == "profile" && <MyAccountCard onCopyPress={onCopyPress} onPress={(data) => onProfileUpdate(data)} data={state} idStatus={getDigitalVerificationStatus(state.idverificationStatus).StatusText} />}
                    {selectedId == "My_Rental_Information" &&
                        <MyRentalInfo
                            data={rentalData}
                            onAddRentalInfo={(data) => {
                                onAddRentalInfo(data)
                            }}
                            onDeletePress={(id) => {
                                onDelereRentalInfo(id)
                            }}
                            onEditPress={(data) => {
                                onEditRentalInfo(data)
                            }}
                        />}
                    {selectedId == "invoice" && <MyInvoiceCard key="invoice-card" invoiceList={<NotificationList />} subscriptionList={<SubscriptionList />} />}

                    {selectedId == "change-password" && <View
                        style={{
                            width: 450,
                            alignSelf: 'center',
                            backgroundColor: 'white',
                            padding: 24,
                            borderRadius: 12,
                            shadowColor: '#101828',
                            shadowOffset: { width: 0, height: 1 },
                            shadowOpacity: 0.1,
                            shadowRadius: 4,
                            elevation: 2,
                        }}>
                        <ChangePasswordCard onChangePassword={(data) => onChangePassword(data)} onClose={() => {
                            if (layoutType === 'web') {
                                navigateAction(props?.navigation, "My Account");
                            } else {
                                setSelectedId('profile');
                            }
                        }} />

                    </View>}
                    {selectedId == 'settings' &&
                        <SettingsCards data={{
                            property_notification: profile?.data?.appUser?.property_notification,
                            marketplace_notification: profile?.data?.appUser?.marketplace_notification,
                            maintenance_notification: profile?.data?.appUser?.maintenance_notification,
                            rental_notification: profile?.data?.appUser?.rental_notification,
                            openflow_notification: profile?.data?.appUser?.openflow_notification,
                        }} onSave={(data) => onUpdateSettings(data)} onClose={() => {
                            if (layoutType === 'web') {
                                navigateAction(props?.navigation, "My Account");
                            } else {
                                setSelectedId('profile');
                            }
                        }} />
                    }
                    {selectedId == 'rent-ready-settings' &&
                        <RentReadySettingsCard
                            documents={docs?.data?.myDocuments}
                            data={{
                                is_tenant_info_shared: rentalProfile?.is_tenant_info_shared,
                                is_right_to_rent_shared: rentalProfile?.is_right_to_rent_shared,
                                is_affordability_shared: rentalProfile?.is_affordability_shared,
                                is_pre_reference_shared: rentalProfile?.is_pre_reference_shared,
                                is_rental_ledger_shared: rentalProfile?.is_rental_ledger_shared,
                                is_id_verification_shared: rentalProfile?.is_id_verification_shared,
                                is_guarantor_affordability_shared: rentalProfile?.is_guarantor_affordability_shared,
                                default_documents_shared: rentalProfile?.default_documents_shared
                            }} onSave={(data) => onUpdateRentReadySettings(data)} onClose={() => {
                                if (layoutType === 'web') {
                                    navigateAction(props?.navigation, "My Account");
                                } else {
                                    setSelectedId('profile');
                                }
                            }} />
                    }
                    {selectedId == "contact-us" && <ContactUsCard data={state} onSend={(data) => onContactUs(data)} />}
                    {selectedId == "saved" && <SavedPropertiesCard />}
                    {selectedId == "alerts" && <AlertCard />}
                    {selectedId == "refer" && <ReferAFriendCard
                        useremail={state.email}
                        shareComponent={() => <ShareMedia
                            // shareUrl={`Refer a friend https://play.google.com/store/apps/details?id=com.tlyfe&hl=en&gl=US`}
                            shareUrl={`Refer a Friend\nCheck it out!\n\nhttps://play.google.com/store/apps/details?id=com.tlyfe&hl=en&gl=US`}

                            emailSubject={
                                "Refer a friend"
                            }
                            emailBody={`Refer a friend https://play.google.com/store/apps/details?id=com.tlyfe&hl=en&gl=US`}
                        />} onSend={(email) => onReferAFriend(email)} />}

                </View>}
            </View>


            <CustomPopUp
                loading={selectedId == "delete" ? true : false}
                primaryButtonText={'Sure'}
                secondaryButtonText={'cancel'}
                primaryText={'Delete Account?'}
                secondaryText={' Are you sure you want to delete your account?'}
                onPrimaryButtonPress={() => {
                    setSelectedId('profile');
                    if (layoutType === 'web') {
                        navigateAction(props?.navigation, "My Account");
                    }
                    dispatch(LogoutApi(true, props.navigation));
                }}
                onSecondaryButtonPress={() => {
                    setSelectedId('profile');
                    setTimeout(() => {
                        scrollViewRef.current?.scrollTo({ y: 0, animated: true });

                    }, 1000);
                    if (layoutType === 'web') {
                        navigateAction(props?.navigation, "My Account");
                    }
                }}
            />

        </BackGroundGenerator>
    );
};
export default MyAccount;
